import { Box, Typography, useTheme } from '@mui/material';

type PropTypes = {
  labelText: string;
};

const Label = ({ labelText }: PropTypes) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: theme.spacing(1),
        width: theme.spacing(5),
        height: theme.spacing(3),
        borderRadius: theme.spacing(0.5),
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.grey[50],
        boxShadow: 'none',
      }}
    >
      <Typography variant="body2" sx={{ fontSize: 12 }}>
        {labelText}
      </Typography>
    </Box>
  );
};

export default Label;
